import { Suspense, type FC } from 'react';
import { Titled } from 'react-titled';
import ProgressSkeleton from 'components/layout/ProgressSkeleton';
import { RuleEdit } from 'features/rules';
import { Box } from '@mui/material';

const RuleDuplicatePage: FC = () => {
  return (
    <Box sx={{ display: 'flex', flexGrow: 1, position: 'relative' }}>
      <Titled title={(title) => `AutoRules | ${title}`} />
      <Suspense fallback={<ProgressSkeleton />}>
        <RuleEdit mode="duplicate" />
      </Suspense>
    </Box>
  );
};

export default RuleDuplicatePage;
